import { ApptModel } from "./appt.model"
import { PetBriefModel } from "./pet-brief.model"

export class RecallModel {
    pet_no: number
    client_no: number
    recall_sequence: number
    recall_date: string
    recall_req_date: string
    status_date: string
    recall_doctor: string
    recall_proc1: string
    recall_proc2: string
    recall_proc3: string
    recall_note: string
    recall_code: string
    recall_status: string
    visible: boolean

    pet_name: string
    specie_name: string
    weight: number
    temperature: number
    color_name: string
    dob: string
    sex: string
    breed_name: string
    client_name: string
    email_address: string
    age: number
    salutation: string
    neuter: string
    pet_code: string
    invoice_limit: number
    home_phone: string
    work_phone: string
    recall_add: string
    pet_active: string
    pet_brief: PetBriefModel[]
    client_appt: ApptModel[]
    client_recall: RecallModel[]
    recall_reason: string
    recall_statusdesc: string
    recall_statuscolor: string
    isEditing: boolean

    constructor(
        pet_no: number,
        client_no: number,
        recall_sequence: number,
        recall_date: string,
        recall_req_date: string,
        status_date: string,
        recall_doctor: string,
        recall_proc1: string,
        recall_proc2: string,
        recall_proc3: string,
        recall_note: string,
        recall_code: string,
        recall_status: string,
        visible: boolean,
        pet_name: string,
        specie_name: string,
        weight: number,
        temperature: number,
        color_name: string,
        dob: string,
        sex: string,
        breed_name: string,
        client_name: string,
        email_address: string,
        age: number,
        pet_brief: PetBriefModel[],
        recall_reason: string,
        recall_statusdesc: string,
        recall_statuscolor: string,
        isEditing: boolean
    ) {
        this.pet_no = pet_no
        this.client_no = client_no
        this.recall_sequence = recall_sequence
        this.recall_date = recall_date
        this.recall_req_date = recall_req_date
        this.status_date = status_date
        this.recall_doctor = recall_doctor
        this.recall_proc1 = recall_proc1
        this.recall_proc2 = recall_proc2
        this.recall_proc3 = recall_proc3
        this.recall_note = recall_note
        this.recall_code = recall_code
        this.recall_status = recall_status
        this.visible = visible
        this.pet_name = pet_name
        this.specie_name = specie_name
        this.weight = weight
        this.temperature = temperature
        this.color_name = color_name
        this.dob = dob
        this.sex = sex
        this.breed_name = breed_name
        this.client_name = client_name
        this.email_address = email_address
        this.age = age
        this.pet_brief = pet_brief
        this.recall_reason = recall_reason
        this.recall_statusdesc = recall_statusdesc
        this.recall_statuscolor = recall_statuscolor
        this.isEditing = isEditing
    }
}